import { lazy } from 'react';

// Types
import { ItemRestrictionMessageProps } from './ItemRestrictionMessage.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "itemRestrictionMessage" */ './ItemRestrictionMessage')),
);

const LazyComponentWithSuspense = withSuspense<ItemRestrictionMessageProps>(LazyComponent, 'ItemRestrictionMessage');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as ItemRestrictionMessage };
